export default __webpack_public_path__ + "static/char-10-anr-abb631e791bc7ee6e606a5867de4d451.webp";